import { useQuery } from "@tanstack/react-query";
import { api } from "@/services/api";

interface TipoTransportadora {
  id: number;
  nome: string;
}

interface Option {
  value: string;
  label: string;
}

export function useTipoTransportadora() {
  return useQuery<Option[]>({
    queryKey: ["tipo-transportadora"],
    queryFn: async () => {
      const { data } = await api.get<TipoTransportadora[]>(
        "/tipo/transportadora"
      );
      return data.map((item) => ({
        value: String(item.id),
        label: item.nome,
      }));
    },
  });
}
